import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';

import 'app/styles/index.css';

if (import.meta.env.VITE_DEVELOPMENT !== 'production') {
  await import('eruda').then((data) => data.default.init());
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
